import axios from 'axios';
import type { AxiosResponse } from 'axios';

export interface RefreshTokenData {
  id_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
}

export interface AuthTokenData extends RefreshTokenData {
  access_token: string;
}

export interface UserPermission {
  role: string;
  permission: string[];
}

export interface UserRoles {
  env: string;
  roles: UserPermission[];
}

export interface UserAccess {
  application: string;
  access: UserRoles[];
}

export interface UserValidation {
  roles: UserAccess;
  allowUser: boolean;
}

export interface CommonServicePayload {
  token: string;
  app: string;
  resource: string;
  stage: string;
}

const sessionAPI = {
  signIn: async () => {
    const redirectURL = await axios.get(
      `${import.meta.env.VITE_APP_AUTH_URL}/signin`,
      {
        params: {
          authority: 'cognito',
          identity_provider: 'Yara-Active-Directory',
          version: 'v2',
        },
        headers: {
          callback: import.meta.env.VITE_APP_URL,
        },
      }
    );
    if (!redirectURL.data.redirectTo) {
      throw new Error(`Couldn't retrieve the redirect URL`);
    }
    window.location.href = redirectURL.data.redirectTo;
  },
  getAuthToken: (code: string): Promise<AxiosResponse<AuthTokenData>> =>
    axios.get(`${import.meta.env.VITE_APP_AUTH_URL}/token`, {
      params: {
        code,
        authority: 'cognito',
        version: 'v2',
        app_id:'DPRT',
      },
      headers: {
        callback: import.meta.env.VITE_APP_URL,
      },
    }),
  refreshAccessToken: async (
    refreshToken: string
  ): Promise<AxiosResponse<RefreshTokenData>> =>
    axios.get(`${import.meta.env.VITE_APP_AUTH_URL}/refresh_token`, {
      params: {
        refresh_token: refreshToken,
        authority: 'cognito',
        version: 'v2',
      },
      headers: {
        callback: import.meta.env.VITE_APP_URL,
      },
    }),
  getUserProfile: async (
    commonServicePayload: CommonServicePayload
  ): Promise<AxiosResponse<UserValidation>> =>
    axios.post(
      `${import.meta.env.VITE_APP_AUTH_URL}/validate_access`,
      commonServicePayload,
      {
        headers: {
          Authorization: commonServicePayload.token,
        },
      }
    ),
};

export default sessionAPI;
